<div class="modal">
    <div class="modal-overlay back-btn" (click)="onCancelClick()"></div>
    <div class="modal-panel" [attr.aria-label]="data.title + '.' + data.message" >
        <div class="title">{{data.title}}</div>
        <div class="message">{{data.message}}</div>

        <div class="actions vertical-focusable-container" data-blocked>
            <button class="btn btn-cta focusable-element" [attr.aria-label]="data.buttonAction | translate" tabindex="0" (click)="onActionProceed()">
                {{data.buttonAction | translate }}</button>
            <button *ngIf="data.buttonCancel" class="btn btn-cancel focusable-element" [attr.aria-label]="data.buttonCancel | translate" tabindex="0" (click)="onCancelClick()">
              {{data.buttonCancel | translate }}</button>
        </div>
    </div>
</div>
